const tier1 = {
    code: 'tier1',
    description: `Family and all court work`,
    taxRate: 0.2,
    services: {
        assessment: {
            preparation: { key: 'B3TKG', chargeRate: 39.92, rate: 39.92, description: 'Reading and Preparation', measure: 'hour', hint: 'Maximum 4 Hours' },
            evaluation: { key: 'ADMINX', chargeRate: 39.92, rate: 39.92, description: 'Assessment Meeting', measure: 'hour', hint: 'Maximum 6 hours' },
            report: { key: 'VS87D', chargeRate: 39.92, rate: 39.92, description: 'Report Writing', measure: 'hour', hint: 'Maximum 6 hours' },
            traveltime: { key: 'CYM2V', rate: 17.32, description: 'Travel Time', measure: 'hour', hint: '' },
        },
        attendance: {
            preparation: { key: 'EJKKB', chargeRate: 39.92, rate: 39.92, description: 'Reading and Preparation', measure: 'hour', hint: 'Maximum 4 Hours' },
            traveltime: { key: 'HHHCO', rate: 17.32, description: 'Travel Time', measure: 'hour', hint: '' },
            fullday: { key: 'G9R4S', rate: 320, chargeRate: 475, description: 'Full Day Hearing', measure: 'day', hint: 'Over 4 hours' },
            halfday: { key: 'XFQN9', rate: 200, chargeRate: 316.68, description: 'Half Day Hearing', measure: 'half day', hint: 'Up to 4 hours' },
            conference: { key: 'XZZZ9', chargeRate: 39.92, rate: 39.92, description: 'Conference Attendance', measure: 'hour', hint: '' },
            cancellation: { key: 'QSZLZ', rate: 300, chargeRate: 475, description: 'Attendance Cancellation', measure: 'day', hint: 'Maximum 3 days' },
            curtailment: { key: 'CMVAX', rate: 300, chargeRate: 475, description: 'Attendance Curtailment', measure: 'day', hint: 'Maximum 3 days' },
        },
    },
    expenses: {
        accommodation: {
            m25: { key: 'ACCOM', rate: 0, description: 'London (inside M25)', measure: 'night', hint: 'Maximum £115 per night', basis: 'cost' },
            birmingham: { key: 'ACCOM', rate: 0, description: 'Birmingham', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            liverpool: { key: 'ACCOM', rate: 0, description: 'Liverpool', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            leeds: { key: 'ACCOM', rate: 0, description: 'Leeds', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            manchester: { key: 'ACCOM', rate: 0, description: 'Manchester', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            newcastle: { key: 'ACCOM', rate: 0, description: 'Newcastle', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            edinburgh: { key: 'ACCOM', rate: 0, description: 'Edinburgh', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            glasgow: { key: 'ACCOM', rate: 0, description: 'Glasgow', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            other: { key: 'ACCOM', rate: 0, description: 'Other', measure: 'night', hint: 'Maximum £80 per night', basis: 'cost' }
        },
        subsistence: {
            partDay: { key: 'SGBXE', rate: 4.25, description: 'Daily Subsistence 5-8', measure: 'day', hint: 'For 5-8 Hours' },
            fullDay: { key: '1VID4', rate: 9.30, description: 'Daily Subsistence 8+', measure: 'day', hint: 'For more than 8 Hours' },
            night: { key: '8VNQE', rate: 26.0, description: 'Night Subsistence', measure: 'night', hint: 'Only when in hotel' }
        },
        travel: {
            publicTransport: { key: 'B3ETD', rate: 0, description: 'Public transport', measure: 'total', hint: 'actual cost', basis: 'cost' },
            sundries: { key: 'B3XFD', rate: 0, description: 'Parking, Tolls etc', measure: 'total', hint: 'Please retain receipts', basis: 'cost' },
            privateCar: { key: 'LIHP7', rate: 0.45, description: 'Travel by Car', measure: 'mile', hint: 'Total miles travelled' },
            privateMotorbike: { key: 'PMIX6', rate: 0.24, description: 'Travel by Motorbike', measure: 'mile', hint: 'Total miles travelled' },
            privateBicycle: { key: 'JYURM', rate: 0.20, description: 'Travel by Bicycle', measure: 'mile', hint: 'Total miles travelled' },
        }
    }
}

const tier2 = {
    code: 'defendant',
    description: `Defendant assessment / report (Legal Aid)`,
    taxRate: 0.2,
    services: {
        assessment: {
            preparation: { key: 'B3TKG', rate: 39.92, description: 'Reading and Preparation', measure: 'hour', hint: 'Maximum 4 Hours' },
            evaluation: { key: 'QUIQR', rate: 39.92, description: 'Assessment Meeting', measure: 'hour', hint: 'Maximum 6 hours' },
            report: { key: 'VS87D', rate: 39.92, description: 'Report Writing', measure: 'hour', hint: 'Maximum 6 hours' },
            traveltime: { key: 'CYM2V', rate: 17.32, description: 'Travel Time', measure: 'hour', hint: '' },
            adminCharge: { key: 'ADMIN01', rate: 40.0, description: 'Administration Charge', measure: 'fee', hint: 'Criminal Jurisdiction Only' },
        },
        attendance: {
            preparation: { key: 'EJKKB', rate: 39.92, description: 'Reading and Preparation', measure: 'hour', hint: 'Maximum 4 Hours' },
            traveltime: { key: 'HHHCO', rate: 17.32, description: 'Travel Time', measure: 'hour', hint: '' },
            fullday: { key: 'G9R4S', rate: 320, chargeRate: 475, description: 'Full Day Hearing', measure: 'day', hint: 'Over 4 hours' },
            halfday: { key: 'XFQN9', rate: 200, chargeRate: 316.68, description: 'Half Day Hearing', measure: 'half day', hint: 'Up to 4 hours' },
            conference: { key: 'XZZZ9', rate: 39.92, description: 'Conference Attendance', measure: 'hour', hint: '' },
            cancellation: { key: 'QSZLZ', rate: 300, chargeRate: 475, description: 'Attendance Cancellation', measure: 'day', hint: 'Maximum 3 days' },
            curtailment: { key: 'CMVAX', rate: 300, chargeRate: 475, description: 'Attendance Curtailment', measure: 'day', hint: 'Maximum 3 days' },
        },
    },
    expenses: {
        accommodation: {
            m25: { key: 'ACCOM', rate: 0, description: 'London (inside M25)', measure: 'night', hint: 'Maximum £115 per night', basis: 'cost' },
            birmingham: { key: 'ACCOM', rate: 0, description: 'Birmingham', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            liverpool: { key: 'ACCOM', rate: 0, description: 'Liverpool', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            leeds: { key: 'ACCOM', rate: 0, description: 'Leeds', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            manchester: { key: 'ACCOM', rate: 0, description: 'Manchester', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            newcastle: { key: 'ACCOM', rate: 0, description: 'Newcastle', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            edinburgh: { key: 'ACCOM', rate: 0, description: 'Edinburgh', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            glasgow: { key: 'ACCOM', rate: 0, description: 'Glasgow', measure: 'night', hint: 'Maximum £100 per night', basis: 'cost' },
            other: { key: 'ACCOM', rate: 0, description: 'Other', measure: 'night', hint: 'Maximum £80 per night', basis: 'cost' }
        },
        subsistence: {
            partDay: { key: 'SGBXE', rate: 4.25, description: 'Daily Subsistence 5-8', measure: 'day', hint: 'For 5-8 Hours' },
            fullDay: { key: '1VID4', rate: 9.30, description: 'Daily Subsistence 8+', measure: 'day', hint: 'For more than 8 Hours' },
            night: { key: '8VNQE', rate: 26.0, description: 'Night Subsistence', measure: 'night', hint: 'Only when in hotel' }
        },
        travel: {
            publicTransport: { key: 'B3ETD', rate: 0, description: 'Public transport', measure: 'total', hint: 'actual cost', basis: 'cost' },
            sundries: { key: 'B3XFD', rate: 0, description: 'Parking, Tolls etc', measure: 'total', hint: 'Please retain receipts', basis: 'cost' },
            privateCar: { key: 'LIHP7', rate: 0.45, description: 'Travel by Car', measure: 'mile', hint: 'Total miles travelled' },
            privateMotorbike: { key: 'PMIX6', rate: 0.24, description: 'Travel by Motorbike', measure: 'mile', hint: 'Total miles travelled' },
            privateBicycle: { key: 'JYURM', rate: 0.20, description: 'Travel by Bicycle', measure: 'mile', hint: 'Total miles travelled' },
        },
    }
}

const tariffs = new Map(
    [
        [tier2.code, tier2],
        [tier1.code, tier1],
    ]
);

const referralServices = [
    { category: 'services', section: 'assessment', code: 'evaluation', key: 'QUIQR', description: 'Assessment & Report', measure: '1 if required', maxValue: 1 },
    { category: 'services', section: 'attendance', code: 'fullday', key: 'G9R4S', description: 'Full Day Hearing', measure: 'day' },
    { category: 'services', section: 'attendance', code: 'halfday', key: 'XFQN9', description: 'Half Day Hearing', measure: 'half day' },
    { category: 'services', section: 'attendance', code: 'conference', key: 'XZZZ9', description: 'Conference Attendance', measure: 'hour' },
];

export {
    tariffs,
    referralServices
}
